module.exports = __webpack_public_path__ + "static/media/clinicaltrials-covid.6119f618.png";